import { Add, Close } from "@mui/icons-material";
import { IconButton, InputAdornment } from "@mui/material";
import { Button, FormField } from "@maysoft/common-component-react";

import InputGroup from "../InputGroup";
import useStrings from "../../hooks/useStrings";

import { Mode } from "../../constants/enums";
import { IPostVideo } from "../../containers/post/usePost";



export const GroupInputLinkVideo = (props: { mode: Mode; postVideos: IPostVideo[]; onValueChange: (data: IPostVideo[]) => void }) => {
    const Strings = useStrings();

    const onAddUrlItem = () => {
        let postVideos = [...(props?.postVideos || [])];
        if (postVideos && postVideos.length > 0) {
            const lastSequence = postVideos[postVideos.length - 1].sequence as number;
            postVideos.push({
                fileUrl: "",
                sequence: lastSequence + 1,
            });
        } else {
            postVideos.push({
                fileUrl: "",
                sequence: 1,
            });
        }

        props.onValueChange(postVideos);
    };

    const onChangeUrlItem = (url: string, index: number) => {
        const postVideos = [...(props?.postVideos || [])];
        if (postVideos && postVideos[index]) {
            postVideos[index].fileUrl = url;
            props.onValueChange(postVideos);
        }
    };

    const onRemoveUrlItem = (index: number) => {
        const postVideos = [...(props?.postVideos || [])];
        if (postVideos && postVideos[index]) {
            postVideos.splice(index, 1);
            props.onValueChange(postVideos);
        }
    };

    const renderVideoItem = (item: IPostVideo, index: number) => {
        return (
            <FormField
                sx={{ mt: 1 }}
                mode={props.mode}
                defaultValue={item?.fileUrl}
                onBlur={(url: any) => onChangeUrlItem(url, index)}
                key={item?.fileUrl || item?.fileId || item?.sequence}
                placeholder={Strings.POST.PLEASE_ENTER_URL_VIDEO_FROM_YOUTUBE}
                label={Strings.format(Strings.POST.LESSON_VIDEO_URL, index + 1).toString()}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={() => onRemoveUrlItem(index)} edge="end">
                                <Close />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
        );
    };

    return (
        <InputGroup title={Strings.POST.VIDEO_NOTE}>
            <div>
                {props.postVideos?.map(renderVideoItem)}
                {props.mode !== Mode.View && (
                    <Button sx={{ mt: 1 }} startIcon={<Add />} onClick={onAddUrlItem}>
                        {Strings.POST.ADD_NEW_VIDEO_LINK}
                    </Button>
                )}
            </div>
        </InputGroup>
    );
};
